import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { IMG } from "@/data/content";
import { Reveal, MaskText } from "@/components/Reveal";

export default function CTABand({
  heading = "Ready to make smarter energy decisions?",
  text = "Talk to a commercial energy advisor about procurement, market strategy, and where IEG can add value across your facilities.",
  primary = { label: "Request a Consultation", to: "/contact" },
  secondary = { label: "Explore Our Services", to: "/solutions" },
}) {
  return (
    <section className="relative overflow-hidden bg-navy-dark text-white">
      <div
        className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-25"
        style={{ backgroundImage: `url(${IMG.transmissionNight})` }}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy-dark via-navy-dark/85 to-navy-dark/60" />
      <div className="relative mx-auto max-w-shell px-6 py-24 md:px-12 md:py-32">
        <div className="max-w-3xl">
          <h2 className="font-heading text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
            <MaskText lines={[heading]} animateOnView />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/70">
              {text}
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-9 flex flex-col gap-4 sm:flex-row">
              <Link
                to={primary.to}
                data-testid="cta-primary"
                className="inline-flex items-center justify-center gap-2 bg-electric px-8 py-4 text-sm font-medium text-white transition-transform hover:scale-[0.97] hover:bg-electric-hover"
              >
                {primary.label}
                <ArrowUpRight className="h-4 w-4" />
              </Link>
              {secondary && (
                <Link
                  to={secondary.to}
                  data-testid="cta-secondary"
                  className="group inline-flex items-center justify-center gap-2 border border-white/30 px-8 py-4 text-sm font-medium text-white transition-colors hover:bg-white hover:text-navy"
                >
                  {secondary.label}
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
